module.exports = __webpack_public_path__ + "static/media/xero.78f0ae42.png";